var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center align-center",staticStyle:{"height":"100%"}},[_c('div',{staticClass:"d-flex flex-column",staticStyle:{"width":"509px"}},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"/img/logo-500x164.png"}}),_vm._v(" "),_c('div',{staticClass:"_backoffice_logo _backoffice_logo_big"},[_vm._v("BACKOFFICE")])])])
}]

export { render, staticRenderFns }